import React from "react";

const DirectHire = () => {
  return (
    <section className="min-h-screen flex items-center justify-center p-6 pt-16 bg-gray-100">
      <article className="bg-transparent shadow-lg rounded-2xl p-8 w-full max-w-3xl">
        <header className="text-center mb-6">
          <h2 className="text-3xl font-bold text-blue-600">Direct Hire</h2>
        </header>

        <section className="mb-6">
          <p className="text-gray-700">
            <b>Direct Hire Recruitment</b> is a strategic staffing solution
            designed for businesses looking to fill permanent roles with highly
            qualified professionals. At <b>Talennect</b>, we specialize in
            identifying and placing top-tier talent that aligns with your
            company’s long-term objectives, culture, and growth vision.
          </p>
        </section>

        <section className="mb-6">
          <h3 className="text-xl font-semibold text-blue-600">
            Why Choose Direct Hire?
          </h3>
          <p className="text-gray-700">
            Hiring full-time employees is a crucial decision that impacts your
            business’s future success. Our <b>direct hire staffing</b> services
            streamline the recruitment process by sourcing, screening, and
            presenting the best candidates—allowing you to focus on your core
            operations. We help companies reduce hiring risks, cut down
            recruitment time, and secure professionals who can contribute from
            day one.
          </p>
        </section>

        <section className="mb-6">
          <h3 className="text-xl font-semibold text-blue-600">
            Our Direct Hire Process
          </h3>
          <p className="text-gray-700">
            Our hiring experts follow a proven methodology to connect you with
            the right talent. We start by understanding your company’s specific
            hiring needs and job requirements. Then, we leverage our{" "}
            <b>
              extensive talent network, AI-driven recruitment tools, and
              industry expertise
            </b>{" "}
            to source and screen candidates. Each candidate undergoes a rigorous
            vetting process, ensuring they meet both technical and cultural fit
            criteria.
          </p>
        </section>

        <section className="mb-6">
          <h3 className="text-xl font-semibold text-blue-600">
            Industries We Serve
          </h3>
          <p className="text-gray-700">
            Our direct hire staffing solutions cater to diverse industries,
            including{" "}
            <b>IT, healthcare, finance, engineering, manufacturing, and more</b>
            . Whether you need a software engineer, financial analyst, or
            healthcare specialist, we deliver the right professionals to help
            you achieve your business objectives.
          </p>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-blue-600">
            Partner with Us for Direct Hire Staffing
          </h3>
          <p className="text-gray-700">
            Finding the perfect full-time employee doesn’t have to be
            time-consuming. Let <b>Talennect</b> be your trusted recruitment
            partner, ensuring you hire top talent efficiently and
            cost-effectively. Contact us today to explore how our{" "}
            <b>direct hire recruitment solutions</b> can support your workforce
            needs.
          </p>
        </section>
      </article>
    </section>
  );
};

export default DirectHire;
